/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, mediaQuery } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION : STYLES --------------- ++++++++++ */
export default theme => ({
  sectioncard: {
    background: 'rgb(255, 255, 255)',
    borderRadius: pxToRem(12),
    border: '1px solid rgb(236, 240, 247)',
    boxShadow: '0px 1px 1px 0px rgb(237, 241, 250)',
    padding: `${pxToRem(32)} ${pxToRem(104)}`,
    [mediaQuery.customizeThinnest]: {
      padding: `${pxToRem(32)} ${pxToRem(32)}`
    },
    '&:not(:first-child)': {
      marginTop: pxToRem(8)
    },
    '& > h2': {
      marginTop: pxToRem(-8),
      color: 'rgb(130, 149, 186)'
    }
  }
});
